// Generated by CoffeeScript 1.11.0
(function() {
  module.exports = require("./Bottleneck");

  if (global.window != null) {
    global.window.Bottleneck = module.exports;
  }

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./node_modules/bottleneck/lib/index.js
// module id = ./node_modules/bottleneck/lib/index.js
// module chunks = 0